export class BaseSheet {
  id: number
  sheet_code: string
  name: string
  curriculum_id: number
  grade: number
  level: string
  question_image_completed: boolean

  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.name = base_sheet.name;
    this.curriculum_id = base_sheet.curriculum_id;
    this.grade = base_sheet.grade;
    this.level = base_sheet.level;
    this.question_image_completed = base_sheet.question_image_completed;
  }
}
